class ImageService {

	constructor() {
		const prefix = process.env.NODE_ENV == 'development' ? 'http://123futalis:123futalis@futalis.server2.voatt.cz' : ''
		this.RACE_SMALL_IMAGES_URL = prefix + '/sites/default/files/aplikace/rasa/small/'
		this.RACE_ORIGINAL_IMAGES_URL = prefix + '/sites/default/files/aplikace/rasa/original/'
		this.SIZE_ORIGINAL_IMAGES_URL = prefix + '/sites/default/files/aplikace/velikost/original/'
	}

	createBase64Image(file) {
		return new Promise((resolve, reject) => {
		    const reader = new FileReader()
		    reader.onload = e => {
		    	return resolve(e.target.result)
		    }
		    reader.onerror = () => reject()

		    reader.readAsDataURL(file)
	  	});
	}
}

export default new ImageService



// WEBPACK FOOTER //
// ./src/services/image-service.js